import React from 'react';
import { Upload, Button, message } from 'antd';
import { PaperClipOutlined, DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import withStyles from 'react-jss';

const styles = () => ({
    uploadContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    fileInfo: {
        fontSize: '12px',
        color: '#666',
        marginLeft: '10px',
    },
});

interface LocationImageUploadProps {
    classes: Record<string, string>;
    fileList: any;
    setFileList: (fileList: any) => void;
    disabled?: boolean;
    maxFileSizeMB?: number;
    existingFile?: any;
    setExistingFile?: any;
}

const LocationImageUpload = (props: LocationImageUploadProps) => {
    const {
        classes,
        fileList,
        setFileList,
        disabled = false,
        maxFileSizeMB = 5,
        existingFile,
        setExistingFile,
    } = props;
    const { t } = useTranslation();

    const fileValidation = (file: any) => {
        // Check file size
        const isValidSize = file.size / 1024 / 1024 < maxFileSizeMB;
        if (!isValidSize) {
            message.error(`${t('file_size_should_be_less_than')} ${maxFileSizeMB} MB`);
            return false;
        }

        // Check file type
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            message.error(t('please_upload_image_file'));
            return false;
        }

        return true;
    };

    const handleBeforeUpload = (file: any) => {
        if (!fileValidation(file)) {
            return Upload.LIST_IGNORE;
        }

        setFileList([file]);

        const reader = new FileReader();
        reader.readAsDataURL(file);

        return false;
    };

    const handleRemove = () => {
        setFileList([]);
        setExistingFile(null);
    };

    return (
        <div className={classes.uploadContainer}>
            <Upload
                fileList={[]}
                beforeUpload={handleBeforeUpload}
                showUploadList={false}
                maxCount={1}
                disabled={disabled}
            >
                <Button disabled={disabled}>
                    <PaperClipOutlined />
                    {t('upload')}
                </Button>
            </Upload>
            {(fileList?.length > 0 || existingFile) && (
                <span className={classes.fileInfo}>
                    {fileList?.length > 0 ? (
                        fileList[0]?.name
                    ) : (
                        <a
                            href={existingFile}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: 'blue',
                                textDecoration: 'underline',
                                maxWidth: '200px',
                                display: 'inline-block',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                verticalAlign: 'middle',
                            }}
                            title={existingFile} // Tooltip on hover
                        >
                            {existingFile}
                        </a>
                    )}
                    <DeleteOutlined
                        onClick={handleRemove}
                        style={{ marginLeft: '8px', color: '#ff4d4f', cursor: 'pointer' }}
                    />
                </span>
            )}
        </div>
    );
};

export default withStyles(styles)(LocationImageUpload);
